import { makeObservable, observable } from 'mobx';
import DrivesViewStore from './DrivesView/DrivesViewStore';
import MyWorkspacesStore from './MyWorkspace/MyWorkspaceStore';
import SharedWithMeStore from './SharedWithMe/SharedWithMeStore';
import ActiveFolderStore from './ActiveFolder/ActiveFolderStore';
import {SelectionStore} from "./Selection/SelectionStore";

export default class DrivesPageStore {

    drivesViewStore;
    myWorkspacesStore;
    sharedWithMeStore;
    activeFolderStore;

    constructor({ drivesStore, foldersStore, documentsStore, filesStore, agentsStore, resourcesStore, usersStore }) {
        this.selectionStore = new SelectionStore();
        
        // Pass this.selectionStore instead of selectionStore
        this.drivesViewStore = new DrivesViewStore({ drivesStore });

        this.myWorkspacesStore = new MyWorkspacesStore({
            foldersStore,
            documentsStore,
            agentsStore,
            drivesStore,
            resourcesStore,
            selectionStore: new SelectionStore(), 
            usersStore
        
        });

        this.sharedWithMeStore = new SharedWithMeStore({
            foldersStore,
            documentsStore,
            filesStore,
            agentsStore,
            resourcesStore,
            selectionStore: new SelectionStore(),
            selectionStore: this.selectionStore
        });

        this.activeFolderStore = new ActiveFolderStore({
            foldersStore,
            documentsStore,
            agentsStore,
            selectionStore: new SelectionStore()
        });

        makeObservable(this, {
            drivesViewStore: observable,
            myWorkspacesStore: observable,
            sharedWithMeStore: observable,
            activeFolderStore: observable
        });
    }
}
